module.exports = __webpack_public_path__ + "img/xg.f5947b4d.png";